import { withBreakpoints } from '../../components/Boneyard';
import SiteLayout from '../../components/SiteLayout';
import SessionExpiredPage from '../../pageComponents/SessionExpiredPage';

const SessionExpired = () => {
  return (
    <SiteLayout title="Session Expired">
      <SessionExpiredPage />
    </SiteLayout>
  );
};

export default withBreakpoints(SessionExpired);
